import React, { ReactElement } from 'react';

import Illustration from 'app/components/Illustration';
import { AppLayout } from 'app/components/styles';
import AppProviders from 'providers/AppProviders';

import AppRoutes from './routes/AppRoutes';

export const App = (): ReactElement => (
  <AppProviders>
    <AppLayout>
      <Illustration />
      <AppRoutes />
    </AppLayout>
  </AppProviders>
);
